import React, {Component} from 'react';

export default class Loading extends Component {
    render() {
        return (<div {...this.props}>
            <i className="fa fa-spinner fa-spin"/>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Loading.js